export const nullish = <TType>(value: Nullish<TType>): boolean => value == null;
